/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { AddToCartData } from '@/types';
import { clickTrack } from '@/utils/analytics/clickTrack';
import root from 'window-or-global';
import { getPageTypeDisplayName } from './trackRecommendationsPageOrZone';

export const trackAddToCartCertonaCartridge = (
  addToCartData: AddToCartData,
  blockId?: string,
  isDealsDrawerMiniCart = false,
  isAcesEnabled = false,
  isMiniCartContext = false,
) => {
  const { pageName = '', pageType = '', siteSection = '' } = window.utag_data ?? {};
  let customLinkName = isDealsDrawerMiniCart
    ? 'Deals Drawer Mini-Certona:Add_to_Cart'
    : `${pageType}-Certona:Add_to_Cart`;

  if (blockId === 'certona-threshold') {
    customLinkName = customLinkName.concat(` - Threshold`);
  }

  const partTypeIds = isAcesEnabled
    ? {
        partGroupId: [addToCartData?.partGroupId],
        partTerminologyId: [addToCartData?.partTerminologyId],
      }
    : {
        originalPartTypeIdList: [addToCartData.originalPartTypeId],
        productRepositoryIdList: [addToCartData.productRepositoryId],
      };

  clickTrack({
    customLinkName,
    eventType: 'addToCart',
    productRecommendationTypeList: 'Certona',
    productBrandList: [addToCartData.brandName],
    productFulfillmentTypeList: [addToCartData.fulFillmentId],
    productIdList: [addToCartData.skuId],
    productPriceList: [addToCartData.price],
    productQuantityList: ['1'],
    productRequestedQuantityList: ['1'],
    productPartNumberList: [addToCartData.productPartNumber],
    productFindingMethod: 'Product Recommendation',
    productRecommendationInteraction: 'productRecommendationInteraction',
    productRecommendationType: isMiniCartContext
      ? 'Mini Cart'
      : `${getPageTypeDisplayName(root.utag_data?.pageType)}: Recommended For You`,
    pageName,
    pageType,
    siteSection,
    ...partTypeIds,
  });
};
